export default function TrustSection() {
  const stats = [
    { value: '10,000+', label: 'Monthly Visitors' },
    { value: '500+', label: 'Curated Finds' },
    { value: '30+', label: 'Buying Guides' },
    { value: 'Weekly', label: 'Updated' },
  ];

  const benefits = [
    {
      text: 'Thousands of organized finds in one place',
      image: 'https://readdy.ai/api/search-image?query=Neatly%20organized%20product%20catalog%20grid%20on%20warm%20cream%20surface%20with%20diverse%20fashion%20items%20arranged%20by%20category%2C%20minimalist%20editorial%20photography%20with%20soft%20natural%20lighting%20from%20above&width=400&height=300&seq=trust-org-finds&orientation=landscape',
    },
    {
      text: 'Easy category navigation for every shopper',
      image: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20interface%20mockup%20showing%20organized%20shopping%20categories%20on%20tablet%20device%20with%20warm%20wooden%20desk%20surface%2C%20soft%20natural%20lighting%2C%20modern%20lifestyle%20photography&width=400&height=300&seq=trust-nav-cat&orientation=landscape',
    },
    {
      text: 'Updated <strong>Vigorbuy Spreadsheet</strong> links every week',
      image: 'https://readdy.ai/api/search-image?query=Modern%20desk%20with%20laptop%20showing%20spreadsheet%20data%20and%20calendar%2C%20sticky%20notes%20and%20coffee%20cup%2C%20warm%20natural%20lighting%2C%20organized%20workspace%20productivity%20photography&width=400&height=300&seq=trust-updated&orientation=landscape',
    },
    {
      text: 'Beginner-friendly buying and shipping guides',
      image: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20shopping%20notes%20next%20to%20packaging%20box%20on%20warm%20wooden%20table%2C%20minimalist%20lifestyle%20photography%20with%20soft%20natural%20lighting%2C%20cozy%20aesthetic&width=400&height=300&seq=trust-guides&orientation=landscape',
    },
  ];

  return (
    <section id="trust" className="relative py-16 md:py-24 bg-accent-100/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50 text-foreground-700 text-xs font-semibold uppercase tracking-wider mb-6">
            Updated Daily
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 leading-tight max-w-2xl mb-10">
            Stop Wasting Hours<br />Searching for Products
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
            {benefits.map((item) => (
              <div key={item.text} className="bg-background-50 rounded-xl overflow-hidden border border-background-200/50">
                <div className="w-full h-36 overflow-hidden">
                  <img
                    src={item.image}
                    alt=""
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <p
                  className="text-foreground-600 text-sm leading-relaxed p-4"
                  dangerouslySetInnerHTML={{ __html: item.text }}
                ></p>
              </div>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 md:gap-10">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-3xl md:text-5xl text-accent-700 mb-1">{stat.value}</p>
              <p className="text-foreground-500 text-sm md:text-base">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}